// AR · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "الجديد في WA Checkin",
  "kicker": "الجديد",
  "stepOf": "الخطوة {n} من {total}",
  "close": "إغلاق",
  "dontShow": "عدم الإظهار مرة أخرى",
  "prev": "السابق",
  "next": "التالي",
  "done": "فهمت",
  "steps": {
    "icons": {
      "title": "أيقونات على حجوزاتك",
      "text": "يعرض كل حجز في التقويم وفي قائمة الحجوزات الآن أيقونات صغيرة: طلبات الاستقبال بالذكاء الاصطناعي والمكالمات والملاحظات وما إذا كان هناك مبلغ مستحق. مرّر المؤشر فوقها لرؤية التفاصيل دون فتح الحجز.",
      "cta": ""
    },
    "early": {
      "title": "تقاضَ رسومًا على الوصول المبكر",
      "text": "يمكن الآن أن يكون للوصول المبكر سعر. يسأل الوكيل الذكي عن وقت الوصول ويحسب التكلفة ويرسل رابط الدفع. وبعد الدفع يتم التأكيد تلقائيًا.",
      "cta": "إعداده في وكيل الذكاء الاصطناعي"
    },
    "reception": {
      "title": "الاستقبال بالذكاء الاصطناعي",
      "text": "كل ما يطلبه ضيوفك من الوكيل (الدخول مبكرًا، المغادرة متأخرًا، ليالٍ إضافية، الفواتير، رسائل المكالمات) يصل إلى صندوق واحد. وافق أو ارفض أو امنح الأولوية بنقرة واحدة وشاهد مبلغ ما يتم تحصيله.",
      "cta": "فتح الاستقبال بالذكاء الاصطناعي"
    },
    "translate": {
      "title": "الترجمة الفورية",
      "text": "فعّل الترجمة في محادثة كل حجز وفي صندوق الوارد: يصلك ما يكتبه الضيف بلغتك، وعند الضغط على Enter ترى أولًا رسالتك مترجمة إلى لغته قبل إرسالها.",
      "cta": "الذهاب إلى الرسائل"
    },
    "voice": {
      "title": "المكالمات مع الوكيل الصوتي",
      "text": "فعّل الاستقبال الهاتفي: يرد الوكيل الذكي على المكالمات بلغة المتصل، ويجيب عن الأسئلة، ويرسل رابط الحجز، ويترك لك ملخصًا لكل مكالمة.",
      "cta": "تفعيل المكالمات"
    }
  },
  "demo": {
    "iconsTipTitle": "الاستقبال بالذكاء الاصطناعي",
    "iconsTipEarly": "وصول مبكر",
    "iconsTipPending": "المتبقي:",
    "paid": "مدفوع",
    "earlyGuest": "هل يمكننا الدخول الساعة 11:00؟",
    "earlyAgent": "نعم! الدخول الساعة 11:00 يكلف 30 €. يمكنك الدفع هنا:",
    "earlyPaid": "مدفوع · مؤكد",
    "rx": {
      "early": "وصول مبكر",
      "late": "مغادرة متأخرة",
      "extend": "تمديد الإقامة"
    },
    "pending": "قيد الانتظار",
    "confirmed": "مؤكد",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "متى يمكننا استلام المفاتيح؟",
    "trMine": "ابتداءً من الساعة 15:00، بانتظاركم",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "ملخص المكالمة",
    "voiceSummary": "سأل عن موقف السيارات وحجز ليلتين. تم إرسال رابط الحجز عبر واتساب."
  }
};
